import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import {Update} from "@ngrx/entity";
import {VisitConfigurationModel} from "../../../models/visit-configuration.model";
import {VisitConfigurationActions, VisitConfigurationAPiActions} from "./visit-configuration.action";
import {ServicesAPiActions} from "../../../../deliveries/angular/state/services.action";

export interface VisitConfigurationState extends EntityState<VisitConfigurationModel> {
  cursor: string;
  isLoading: boolean;
}

const adapter: EntityAdapter<VisitConfigurationModel> = createEntityAdapter<VisitConfigurationModel>();

const initialState: VisitConfigurationState = adapter.getInitialState({
  cursor: null,
  isLoading: false
});

const reducer = createReducer(
  initialState,


  // Get Many
  on(VisitConfigurationAPiActions.getMany, (state) => ({...state, isLoading: true})),
  on(VisitConfigurationAPiActions.getManySuccess, (state, {visitConfigurations, cursor}) =>
    adapter.setMany(visitConfigurations, {...state, cursor: cursor, isLoading: false})
  ),
  on(VisitConfigurationAPiActions.getManyFailure, (state) => ({...state, isLoading: false})),


  // Get One
  on(VisitConfigurationAPiActions.getOne, (state) => ({...state, isLoading: true})),
  on(VisitConfigurationAPiActions.getOneSuccess, (state, {visitConfiguration}) =>
    adapter.setOne(visitConfiguration, {...state, isLoading: false})
  ),
  on(VisitConfigurationAPiActions.getOneFailure, (state) => ({...state, isLoading: false})),


  // Create One
  on(VisitConfigurationAPiActions.createOne, (state) => ({...state, isLoading: true})),
  on(VisitConfigurationAPiActions.createOneSuccess, (state, {visitConfiguration}) => {
      return adapter.setOne(visitConfiguration, {...state, isLoading: false})
    }
  ),
  on(VisitConfigurationAPiActions.createOneFailure, (state) => ({...state, isLoading: false})),


  // Update One
  on(VisitConfigurationAPiActions.updateOne, (state) => ({...state, isLoading: true})),
  on(VisitConfigurationAPiActions.updateOneSuccess, (state, {visitConfiguration}) => {
      return adapter.setOne(visitConfiguration, {...state, isLoading: false})
    }
  ),
  on(VisitConfigurationAPiActions.updateOneFailure, (state) => ({...state, isLoading: false})),


  // Delete One
  on(VisitConfigurationAPiActions.deleteOne, (state) => ({...state, isLoading: true})),
  on(VisitConfigurationAPiActions.deleteOneSuccess, (state, {id}) =>
    adapter.removeOne(id, {...state, isLoading: false})
  ),
  on(VisitConfigurationAPiActions.deleteOneFailure, (state) => ({...state, isLoading: false})),


  on(VisitConfigurationActions.clearStore, () => ({...initialState}))
);

export const visitConfigurationsFeature = createFeature({
  name: 'VisitConfigurations',
  reducer,
  extraSelectors: ({selectEntities, selectCursor, selectIsLoading, selectVisitConfigurationsState}) => ({
    ...adapter.getSelectors(selectVisitConfigurationsState),
    selectMany: () => createSelector(
      selectEntities,
      (entities) => Object.values(entities),
    ),
    selectByIds: (ids: string[]) => createSelector(
      selectEntities,
      (entities) => {
        const list = [];
        ids?.forEach(id => {
          if (!!entities[id]) {
            list.push(entities[id]);
          }
        })
        return list;
      }
    ),
    selectOne: (id: string) => createSelector(
      selectEntities,
      (entities) => entities[id],
    ),
    selectCursor: () => createSelector(
      selectCursor,
      (cursor) => cursor
    ),
    selectIsLoading: () => createSelector(
      selectIsLoading,
      (isLoading) => isLoading
    )
  }),
})



















// import {ActionReducer, createFeature, createReducer, createSelector, on, select} from '@ngrx/store';
// import {EntityState, EntityAdapter, createEntityAdapter, Dictionary} from '@ngrx/entity';
// import {Update} from "@ngrx/entity";
// import {
//   VisitConfigurationAPiActions,
//   VisitConfigurationChannelActions,
//   VisitConfigurationActions
// } from "./visit-configuration.action";
// import {uniq, uniqBy} from "lodash";
// import {VisitConfigurationModel} from "../../../models/visit-configuration.model";
// import {AccountsAPiActions} from "../../../../account/angular/state/accounts.actions";
//
// export interface VisitConfigurationState extends EntityState<VisitConfigurationModel> {
//   cursor: string;
//   isLoading: boolean;
//   infiniteScrollIds: string[]
// }
//
// const adapter: EntityAdapter<VisitConfigurationModel> = createEntityAdapter<VisitConfigurationModel>();
//
// const initialState: VisitConfigurationState = adapter.getInitialState({
//   cursor: null,
//   isLoading: false,
//   infiniteScrollIds: []
// });
//
//
// const reducer: ActionReducer<VisitConfigurationState> = createReducer(
//   initialState,
//
//   // on(VisitConfigurationChannelActions.notificationReceived, (state, {notification}) => {
//   //   if (state.entities[notification.id]?.updatedAt < notification.updatedAt) {
//   //     return adapter.setOne(notification, state);
//   //   } else {
//   //     return state;
//   //   }
//   // }),
//   //
//   // on(VisitConfigurationChannelActions.partialNotificationReceived, (state, {notification}) => {
//   //
//   //   if (state.entities[notification.id]?.updatedAt < notification.updatedAt) {
//   //     const changes: Update<VisitConfigurationModel> = {
//   //       id: notification.id,
//   //       changes: {...notification}
//   //     }
//   //     return adapter.updateOne(changes, state);
//   //   } else {
//   //     return state;
//   //   }
//   // }),
//
//   on(VisitConfigurationAPiActions.getOne, (state) => ({...state, isLoading: true})),
//
//   on(VisitConfigurationAPiActions.getOneSuccess, (state, {visitConfiguration}) => {
//     return adapter.setOne(visitConfiguration, {...state, isLoading: false})
//   }),
//
//   on(VisitConfigurationAPiActions.getInfiniteScroll, (state) => ({...state, isLoading: true})),
//
//   on(VisitConfigurationActions.updateOne, (state, {visitConfiguration}) => {
//     if (!!visitConfiguration) {
//       const changes: Update<VisitConfigurationModel> = {
//         id: visitConfiguration.id,
//         changes: {...visitConfiguration}
//       }
//       return adapter.updateOne(changes, state);
//     }
//   }),
//
//   on(VisitConfigurationActions.updateMany, (state, {visitConfigurations}) => {
//     if (visitConfigurations.length) {
//       const changes = [];
//       visitConfigurations?.forEach((s) => {
//         const change: Update<VisitConfigurationModel> = {
//           id: s.id,
//           changes: {...s}
//         }
//         changes.push(change)
//       })
//       return adapter.updateMany(changes, state);
//     }
//   }),
//
//
//   on(VisitConfigurationAPiActions.getInfiniteScrollSuccess, (state, {visitConfigurations, cursor}) =>
//     adapter.setMany(visitConfigurations, {...state, cursor: cursor})
//   ),
//
//   on(VisitConfigurationAPiActions.getMany, (state) => ({...state, isLoading: true})),
//
//   on(VisitConfigurationAPiActions.getManySuccess, (state, {visitConfigurations}) => {
//     return adapter.setMany(visitConfigurations, {...state, isLoading: false})
//   }),
//
//   on(VisitConfigurationActions.setMany, (state, {visitConfigurations, isAppendFirst}) => {
//     if (isAppendFirst) {
//       const currentEntitiesInStore = Object.values(state.entities);
//       const entitiesArr = uniqBy([...visitConfigurations, ...currentEntitiesInStore], 'id');
//       return adapter.setAll(entitiesArr, state);
//     } else {
//       return adapter.setMany(visitConfigurations, state)
//     }
//   }),
//
//   on(VisitConfigurationActions.setInfiniteScrollIds, (state, {ids, isAppendFirst}) => {
//     let newState = state;
//     const currentInfiniteScrollIdsInStore = state.infiniteScrollIds;
//
//     if (isAppendFirst) {
//       newState = {
//         ...newState,
//         infiniteScrollIds: uniq([...ids, ...currentInfiniteScrollIdsInStore])
//       }
//     } else {
//       newState = {
//         ...newState,
//         infiniteScrollIds: uniq([...currentInfiniteScrollIdsInStore, ...ids])
//       }
//     }
//     return newState;
//
//   }),
//
//   on(VisitConfigurationActions.removeMany, (state, {ids}) => adapter.removeMany(ids, state)),
//
//   on(VisitConfigurationActions.removeAll, (state) => adapter.removeAll(state)),
//
//   on(VisitConfigurationActions.clearStore, () => ({...initialState}))
// );
//
// export const visitConfigurationsFeature = createFeature({
//   name: 'VisitConfigurations',
//   reducer,
//   extraSelectors: ({
//                      selectVisitConfigurationsState,
//                      selectEntities,
//                      selectCursor,
//                      selectIsLoading,
//                      selectInfiniteScrollIds,
//                    }) => ({
//     ...adapter.getSelectors(selectVisitConfigurationsState),
//     selectMany: () => createSelector(
//       selectEntities,
//       (entities) => {
//         return Object.values(entities)
//       },
//     ),
//     selectInfiniteScroll: () => createSelector(
//       selectEntities,
//       selectInfiniteScrollIds,
//       (entities, infiniteScrollIds) => {
//         const infiniteScrollEntities = [];
//         infiniteScrollIds.forEach(id => {
//           if (!!entities[id]) {
//             infiniteScrollEntities.push(entities[id]);
//           }
//         })
//         return infiniteScrollEntities;
//       },
//     ),
//     selectManyById: (ids: string[]) => createSelector(
//       selectEntities,
//       (entities) => {
//         const list = [];
//         ids?.forEach(id => {
//           if (!!entities[id]) {
//             list.push(entities[id]);
//           }
//         })
//         return list;
//       },
//     ),
//     selectOne: (id: string) => createSelector(
//       selectEntities,
//       (entities: Dictionary<VisitConfigurationModel>) => entities[id],
//     ),
//     selectCursor: () => createSelector(
//       selectCursor,
//       (cursor) => cursor
//     ),
//     selectIsLoading: () => createSelector(
//       selectIsLoading,
//       (isLoading) => isLoading
//     )
//   })
// });
